import { Text, Tooltip } from '@chakra-ui/react';

const TruncatedText = ({
  text,
  maxLength = 18,
  openDelay = 500,
  fontWeight,
  color,
  fontSize,
  noOfLines,
  wordBreak,
}: {
  text: string;
  maxLength?: number;
  openDelay?: number;
  fontWeight?: string;
  color?: string;
  fontSize?: string;
  noOfLines?: number;
  wordBreak?: 'break-all';
}) => {
  if (text.length <= maxLength) {
    return (
      <Text
        variant='small'
        w='full'
        textAlign='center'
        whiteSpace='nowrap'
        fontWeight={fontWeight}
        color={color}
        fontSize={fontSize}
        noOfLines={noOfLines}
        wordBreak={wordBreak}
      >
        {text}
      </Text>
    );
  }

  const partLength = Math.floor(maxLength / 2);
  const start = text.slice(0, partLength);
  const end = text.slice(text.length - partLength);

  const truncatedText = `${start}...${end}`;

  return (
    <Tooltip label={text} openDelay={openDelay} aria-label={text}>
      <Text
        variant='small'
        w='full'
        textAlign='center'
        whiteSpace='nowrap'
        fontWeight={fontWeight}
        color={color}
        fontSize={fontSize}
        noOfLines={noOfLines}
        wordBreak={wordBreak}
      >
        {truncatedText}
      </Text>
    </Tooltip>
  );
};

export default TruncatedText;
